import {difference} from 'lodash'
const _ = require('lodash')

angular.module('clientDashboardApp').directive('gadgetFilter', function ($q, $http) {
  return {
    scope: {
      filter: '=',
      gadget: '=',
      accounts: '=',
      inheritedGadget: '&',
    },
    template: require("./gadgetFilter.html"),
    controller: ($scope) => {

      $scope.filter.accessor.initialize = initialize

      let originalGadget = $scope.gadget
      $scope.theInheritedGadget = null

      function initialize() {
        $scope.theInheritedGadget = $scope.inheritedGadget({gadget:originalGadget})
        $scope.gadget = originalGadget ? $scope.theInheritedGadget || originalGadget : {}
        $scope.disableAll = !!$scope.theInheritedGadget
      }

      initialize()

      $scope.dropdownModel = function(newVal) {
        if (typeof newVal !== "undefined") {
          $scope.gadget[$scope.filter.name] = newVal
        }
        return $scope.gadget[$scope.filter.name]
      }

      $scope.radioModel = function(radioValue) {
        return $scope.multiselectModel(radioValue, true)
      }

      $scope.multiselectModel = function(checkboxValue, exclusive) {
        return (checked) => {
          if (typeof checked !== "undefined") {
            if (checked) {
              if (exclusive) {
                $scope.gadget[$scope.filter.name] = checkboxValue
              } else {
                $scope.gadget[$scope.filter.name] = $scope.gadget[$scope.filter.name] || []
                $scope.gadget[$scope.filter.name].push(checkboxValue)
                $scope.gadget[$scope.filter.name] = _.uniq($scope.gadget[$scope.filter.name])
              }
            } else {
              if (exclusive) {
                delete $scope.gadget[$scope.filter.name]
              } else {
                _.pull($scope.gadget[$scope.filter.name], checkboxValue)
              }
            }
          }

          if (exclusive) {
            return $scope.gadget[$scope.filter.name] === checkboxValue
          } else {
            return ($scope.gadget[$scope.filter.name] || []).indexOf(checkboxValue) !== -1
          }
        }
      }

      function initializeRadio(options) {
        if (options === undefined) {
          return
        }

        if ($scope.filter.name === "accountId" && $scope.accounts && $scope.accounts.length) {
          $scope.options = options.filter(option => $scope.accounts.indexOf(option.value) >= 0)
        }

        if ($scope.options.length > 0 && $scope.filter.type === 'radio' && (!$scope.gadget[$scope.filter.name] || !$scope.options.find(option => option.value === $scope.gadget[$scope.filter.name]))) {
          $scope.gadget[$scope.filter.name] = $scope.options[0].value
        }
      }

      if (typeof $scope.filter.options === "function") {
        $scope.filter.options().then(res => {
          $scope.options = res;
          $scope.filter.options = $scope.options.slice(0, $scope.options.length);
          initializeRadio($scope.options);
        })
      } else if (typeof $scope.filter.optionsPromise !== "undefined" && $scope.filter.options === undefined) {
        $scope.filter.optionsPromise.then(res => {
          $scope.options = res;
          delete $scope.filter.optionsPromise
          $scope.filter.options = $scope.options.slice(0, $scope.options.length);
          initializeRadio($scope.options);
        })
      } else {
        $scope.options = $scope.filter.options
        initializeRadio($scope.options);
      }
    }
  }

});
